export enum PRODUCTION_LINES_DIALOG_TYPES {
    ADD = 'add',
    EDIT = 'edit'
}